export default __webpack_public_path__ + "static/media/TheWorldEngland_08.ac262673.png";